<p-confirmdialog />
<app-toast-container />

<ion-app>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
